import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbDialogService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { InternalSearchService } from '../../internal-search.service';
import { UserService } from '../../../user/user.service';
import { ConfirmOperationComponent } from '../../../../../@theme/components/confirm-operation/confirm-operation.component';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-dashboard-detail',
  templateUrl: 'dashboard-detail.component.html',
  styleUrls: ['dashboard-detail.component.scss'],
})
export class DashboardDetailComponent implements OnInit {

  public internalSearchId;
  public userId;

  public questions = [];
  public user;
  isOpenAll = false;

  @ViewChild('item', { static: false }) accordion;


  constructor(private route: ActivatedRoute, private userService: UserService,
    private internalSearchService: InternalSearchService, private router: Router,
    private dialogService: NbDialogService,
    private location: Location,
    private toastrService: NbToastrService) {
    this.internalSearchId = this.route.snapshot.params.internalSearchId;
    this.userId = this.route.snapshot.params.userId;
    this.getUser();
  }

  getUser() {
    this.userService.findByid(this.userId).toPromise().then(result => {
      this.user = result;
    });
  }

  toggleAccordion() {
    this.isOpenAll = !this.isOpenAll;
    if (this.isOpenAll) {
      this.openAll();
    } else {
      this.closeAll();
    }
  }

  openAll() {
    this.accordion.openAll();
  }

  closeAll() {
    this.accordion.closeAll();
  }

  onDeleteConfirm(): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Excluir respostas',
        text: `Você realmente deseja excluir as respostas do usuário ${this.user.firstName}?`,
        accent: 'danger',
        LabelForce: 'Excluir respostas'
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(this.user.id));
  }

  delete(userId) {
    this.internalSearchService.removeAnswers(userId, this.internalSearchId).toPromise().then(result => {
      this.toastrService.show('Pesquisa', 'Respotas excluida com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.goBack();
    })
  }


  ngOnInit() {
    this.internalSearchService.findDashDetail(this.userId, this.internalSearchId).toPromise().then(result => {
      this.questions = result.body;
      this.questions.sort((a, b) => a.order - b.order);
      for (let i = 0; i < this.questions.length; i++) {
        const question = this.questions[i];
        question.responses.sort((a, b) => a.order - b.order);
      }
    });
  }

  goBack() {
    this.location.back();
  }


}
